import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import useTranslationDashboard from "../useTranslationDashboard";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import DashboardActiveApplicationsList from "./DashboardActiveApplicationsList";
import DashboardAlertsList from "./DashboardAlertsList";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../../constants/routes";
import TotalRevenueItem from "./TotalRevenueItem";
import CandidatesByStatusCountItem from "./CandidatesByStatusCountItem";
import ActionLink from "../../common/widgets/ActionLink";
import RefreshButton from "../../common/widgets/RefreshButton";
import "./DashboardBlock.scss";
import RecommendCard from "./RecommendCard";

function DashboardBlock(props) {
  const { recruiterId } = props;

  const { t, loading: tLoading } = useTranslationDashboard();
  useShowLoader(tLoading, "DashboardBlock");
  const history = useHistory();

  const onClickViewAll = (event) => {
    event.preventDefault();
    history.push(ROUTES.RECRUITER_CANDIDATES);
  };

  return (
    <div className="DashboardBlock">
      <Row>
        <Col>
          <h1>{t("dashboard:recruiters_dashboard_title")}</h1>
        </Col>
        <Col className={"link-col"}>
          <RefreshButton />
        </Col>
      </Row>

      <Row>
        <Col>
          <div className="dashboardStatisticalBlocs">
            <Row className={"list-row "}>
              <Col className="information-col">
                <div className="sub-block">
                  <RecommendCard />
                </div>
              </Col>
              <Col className="information-col">
                <div className="sub-block">
                  <TotalRevenueItem recruiterId={recruiterId} />
                </div>
              </Col>
              <Col className="information-col">
                <div className="sub-block">
                  <CandidatesByStatusCountItem
                    recruiterId={recruiterId}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <Row className="list-row">
        <Col>
          <DashboardAlertsList recruiterId={recruiterId} />
        </Col>
      </Row>
      <Row>
        <Col>
          <div className={"widget-block"}>
            <Row className="list-row">
              <Col>
                <DashboardActiveApplicationsList recruiterId={recruiterId} />
              </Col>
            </Row>
            <Row className="list-row">
              <Col>
                <ActionLink onClick={onClickViewAll}>
                  {t(
                    "dashboard:recruiters_dashboard_applications_list_view_all_link"
                  )}
                </ActionLink>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default DashboardBlock;
